import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DisclaimerContainerStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const StepHeaderLabelStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.popupWindowTitle,
  fontSize: '14px',
  fontWeight: 'bold',
  margin: '8px 0 0 16px',
  textTransform: 'uppercase',
}));

export const StepperBoxOut = styled(Box)(({ theme }) => ({
  border: `8px solid ${theme.palette.colors.popupWindow}`,
  borderRadius: '12px',
  background: theme.palette.colors.popupWindow,
  margin: 'auto',
  [theme.breakpoints.up('xxl')]: {
    width: '1191px',
    minHeight: '418px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    width: '890px',
    minHeight: '418px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    width: '484px',

    marginBottom: 72,
  },
  [theme.breakpoints.down('sm')]: {
    width: 344,

    marginBottom: 80,
  },
}));

export const StepperBoxIn = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.colors.primaryBackground}`,
  background: theme.palette.colors.primaryBackground,
  borderRadius: '5px',
  margin: '6px 0 0',
  display: 'flex',
  [theme.breakpoints.up('xxl')]: {
    padding: '3px 6px 9px 8px',
    width: 1175,
    minHeight: 367,
    flexDirection: 'row',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    padding: '3px 6px 9px 8px',
    width: 874,
    minHeight: 367,
    flexDirection: 'row',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    padding: '8px',
    width: 468,
    height: 'auto',
    flexDirection: 'column',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '8px',
    width: 328,
    height: 'auto',
    flexDirection: 'column',
  },
}));

export const RightContainer = styled(Box)(({ theme }) => ({
  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },

  [theme.breakpoints.up('lg')]: {
    overflow: 'auto',
    paddingRight: '16px',
  },
}));

export const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'row',
  margin: '9px 6px 12px 12px',

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },

  [theme.breakpoints.up('xxl')]: {
    height: '65px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    height: '109px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    height: '64px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '94px',
  },
}));

export const BoxContainerStyled = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xxl')]: {
    width: '40%',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    width: '40%',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    padding: '0 8px 0 8px',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px 0 16px',
    width: '100%',
  },
}));

export const IssueTextStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colors.infoBackground,
  marginTop: '24px',
  borderRadius: 5,
  [theme.breakpoints.up('xxl')]: {
    height: '115px',
  },
}));

export const ActionContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.up('xxl')]: {
    width: '1175',
    minHeight: '402px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    width: 874,
    minHeight: 402,
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    width: 468,
  },
  [theme.breakpoints.down('sm')]: {
    width: '328px',
  },
}));

export const SimulationChargesBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const HeaderDisclaimerStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  padding: '18px 21px 0 12px',
  fontWeight: 500,
  lineHeight: 'normal',
}));

export const StepperContainerStyled = styled(Box)(() => ({
  width: '100%',
}));

export const StepActionsContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'absolute',
  right: theme.spacing(3),
  bottom: theme.spacing(3),
}));

export const SimulationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));
